import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Table } from 'components/Table/Table';
import { PopupTopBar } from 'components/PopupTopbar';

type TreeStoresPopup = {
	show: boolean;
	treeStores:any;
	handleClose: () => void;
	saveSelectedRows: (saved: boolean, newStores?: []) => void;
};

export function TreeStoresPopup(props: any) {
	const [selectedRows, setSelectedRows] = useState<any>([]);
	const [saving, setSaving] = useState(false);
	const [counterSelectedRows, setCounterSelectedRows] = useState<number>(0);
	const columnsb = [
		{
			Header: 'Name',
			accessor: 'name',
			width: 500,
		},
	];

	useEffect(() => {
		if (props.show) setSaving(false);
	}, [props.show]);

	useEffect(() => {
		let rows:number = 0;
		if(selectedRows.length > 0 ) rows = selectedRows.length;
		setCounterSelectedRows(rows);
	}, [selectedRows]);

	function saveSelectedStores() {
		props.saveSelectedRows(true, selectedRows);
	}

	return (
		<Modal size="lg" centered show={props.show} onHide={props.handleClose}>
			<Modal.Header closeButton>
				<Modal.Title>Stores</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Table 
					pageSize={15}
					isSortable={true}
					pagination={true}
					isSelectable={true}
					isSearchable={true}
					disableExport={true}
					columns={columnsb}
					data={props.treeStores || []}
					selectedRowsUpdate={(rows: any) => setSelectedRows(rows)}
					topbarChild={<PopupTopBar counter={counterSelectedRows} onSave={saveSelectedStores} saving={saving} />}
				/>
			</Modal.Body>
		</Modal>
	);
}